import InnerHTML from "dangerously-set-html-content";
import { t } from "@/i18n-js/instance";
import type { AccessGroupEntryPoint } from "@/react/helpers/accessGroups/accessGroupHelpers";
import { accessGroupEntryPoints } from "@/react/helpers/accessGroups/accessGroupHelpers";
import { settingsNavPathV3 } from "@circle-react/helpers/urlHelpers";
import { Typography } from "@circle-react-uikit/Typography";
import { ONBOARDING_KB_ARTICLE_URL } from "./constants";

interface AccessGroupTitleProps {
  areFormItemsEmbedded: boolean;
  recordType: AccessGroupEntryPoint;
}

const i18nRoot = "settings.access_groups.admin.entry_points.association";

const titleTranslationKeys: Partial<Record<AccessGroupEntryPoint, string>> = {
  [accessGroupEntryPoints.communitySetting]: "onboarding_settings.title",
  [accessGroupEntryPoints.invitationLink]: "invitation_link.title",
};

const getTitle = (recordType: AccessGroupEntryPoint) => {
  const translationKey = titleTranslationKeys[recordType];
  return translationKey ? t([i18nRoot, translationKey]) : null;
};

const descriptionData: Record<
  AccessGroupEntryPoint,
  { translationKey: string; url?: string }
> = {
  [accessGroupEntryPoints.communitySetting]: {
    translationKey: "onboarding_settings.description",
    url: ONBOARDING_KB_ARTICLE_URL,
  },
  [accessGroupEntryPoints.invitationLink]: {
    translationKey: "invitation_link.description",
  },
  [accessGroupEntryPoints.memberBulkImport]: {
    translationKey: "bulk_members_import.description",
  },
  [accessGroupEntryPoints.paywall]: {
    translationKey: "paywall.description",
  },
};

const getDescription = (recordType: AccessGroupEntryPoint) => {
  const data = descriptionData[recordType];
  const defaultUrl = `${window.location.origin}${settingsNavPathV3.members.onboarding_access}`;
  const url = data.url || defaultUrl;

  return t([i18nRoot, data.translationKey], { url });
};

export const AccessGroupHeader = ({
  areFormItemsEmbedded,
  recordType,
}: AccessGroupTitleProps) => {
  const Title = areFormItemsEmbedded ? Typography.LabelMd : Typography.TitleSm;
  const Description = areFormItemsEmbedded
    ? Typography.BodySm
    : Typography.BodyMd;

  const title = getTitle(recordType);
  return (
    <>
      {title && <Title weight="semibold">{title}</Title>}

      <div className="mb-8 pt-2">
        <Description
          weight={areFormItemsEmbedded ? "normal" : "semibold"}
          color="text-dark"
        >
          <InnerHTML html={getDescription(recordType)} />
        </Description>
      </div>
    </>
  );
};
